import { TCoordinates, TLocationCoords } from '@/types';

function toRadians(degrees: number): number {
  return degrees * (Math.PI / 180);
}

function toDegrees(radians: number): number {
  return radians * (180 / Math.PI);
}

export function calculateTrajectoryAngle(start: TCoordinates, end: TCoordinates): number {
  const deltaLat = Number(end.lat) - Number(start.lat);
  const deltaLon = Number(end.lon) - Number(start.lon);
  return toDegrees(Math.atan2(deltaLon, deltaLat)); // atan2 gives the angle in radians
}

export function moveAlongTrajectoryByDegrees(start: TCoordinates, angle: number, distance: number): TCoordinates {
  // Convert the distance to radians (approximate; small distance considered as degrees)
  const deltaLat = distance * Math.cos(toRadians(angle));
  const deltaLon = distance * Math.sin(toRadians(angle));

  const newLat = Number(start.lat) + deltaLat;
  const newLon = Number(start.lon) + deltaLon;

  return { lat: newLat, lon: newLon };
}

export const calculateDegreeDistance = (coord1: TCoordinates, coord2: TCoordinates) => {
  const latDiff = Math.abs(Number(coord1.lat) - Number(coord2.lat));
  const lonDiff = Math.abs(Number(coord1.lon) - Number(coord2.lon));
  return Math.sqrt(latDiff ** 2 + lonDiff ** 2);
};

export const calculateMaxDistance = (points: Array<TLocationCoords>) => {
  let maxDist = 0;

  for (let i = 0; i < points.length; i++) {
    for (let j = i + 1; j < points.length; j++) {
      const dist = calculateDegreeDistance(points[i], points[j]);
      maxDist = Math.max(maxDist, dist);
    }
  }

  return maxDist;
};
